/**
 * SDK version string. Injected at build time by Vite's `define` from
 * package.json — single source of truth.
 *
 * Emitted as a header on every request so platform-side logs can
 * attribute traffic to SDK versions.
 *
 * Falls back to a sentinel when consumed outside the Vite build (e.g.
 * unit tests run via tsx) so the import never throws.
 */
declare const __SDK_VERSION__: string | undefined;

export const SDK_VERSION: string =
  typeof __SDK_VERSION__ !== 'undefined' ? __SDK_VERSION__ : '0.0.0-dev';
